import React from 'react';
import ReviewCTA from './MessageBubble/ReviewCTA';
import ITPRewardExchangeCTA from './MessageBubble/ITPRewardExchangeCTA';
import CompleteBubble from './CommonBubble/CompleteBubble';
import ChatMessageProfileImgPresenter from './ChatMessageProfileImgPresenter';
import ChatMessageBubbleAdormentPresenter from './ChatMessageBubbleAdormentPresenter';
import MessageBubble from './MessageBubble';

import {
  CapaQuotationChatMessage,
  CapaQuotationChatMessageRfq,
  CapaQuotationChatMessageType,
  CapaQuotationUserRfqDetail,
  CapaQuotationUserType
} from '@generated/graphql';

import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';

import useStyles from './useStyles';

interface Props {
  isOwner: boolean;
  message?: CapaQuotationChatMessage;
  rfqDetail?: CapaQuotationUserRfqDetail;
}

const ChatMessageBubblePresenter: React.FC<Props> = ({
  isOwner,
  message,
  rfqDetail
}) => {
  const messageType = message?.message?.messageType ?? undefined;

  const classes = useStyles();

  const invisibleTypes = [
    CapaQuotationChatMessageType.InduceQuotationRequest,
    CapaQuotationChatMessageType.InduceRegisterTransactionReview
  ];

  const messageTypeName = message?.message?.__typename;
  const managerName = message?.managerName ?? undefined;

  if (
    message?.message?.__typename === 'CAPAQuotationBypassMessage' &&
    message.senderUserType !== CapaQuotationUserType.Client
  )
    return null;

  if (
    message?.message &&
    invisibleTypes.includes(message?.message?.messageType) &&
    !(message?.message as CapaQuotationChatMessageRfq).rfq?.isVisible
  ) {
    return null;
  }

  if (
    messageTypeName === 'CAPAQuotationChatMessageRfq' &&
    messageType === CapaQuotationChatMessageType.RfqComplete
  ) {
    const data = message?.message as CapaQuotationChatMessageRfq;

    return (
      <>
        <div className={classes['Chat-Message-Bubble-root']}>
          <ChatMessageBubbleAdormentPresenter
            isOwner={isOwner}
            message={message}
          />
          <ReviewCTA data={data} />
        </div>
        {rfqDetail?.transaction?.isItp && (
          <div className={classes['Chat-Message-Bubble-root']}>
            <ChatMessageBubbleAdormentPresenter
              isOwner={isOwner}
              message={message}
            />
            <ITPRewardExchangeCTA />
          </div>
        )}
        <div className={classes['Chat-Message-Bubble-root']}>
          <ChatMessageBubbleAdormentPresenter
            isOwner={isOwner}
            message={message}
          />
          <CompleteBubble data={data} />
        </div>
      </>
    );
  }

  return (
    <div id="message" className={classes['Chat-Message-Bubble-root']}>
      <div
        className={clsx('bubble-container', {
          owner: isOwner
        })}
      >
        <ChatMessageProfileImgPresenter isOwner={isOwner} message={message} />
        <div className="bubble-wrapper">
          {!isOwner && managerName && (
            <CustomizedTypography
              className="manager-name"
              variant="subtitle2"
              color="textSecondary"
              gutterBottoms={8}
              noWrap
            >
              {managerName}
            </CustomizedTypography>
          )}
          <div className="bubble-content">
            {isOwner && (
              <ChatMessageBubbleAdormentPresenter
                isOwner={isOwner}
                message={message}
              />
            )}
            <MessageBubble isOwner={isOwner} message={message} />
            {!isOwner && (
              <ChatMessageBubbleAdormentPresenter
                isOwner={isOwner}
                message={message}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessageBubblePresenter;
